export type OrgRole = 'ceo' | 'vp' | 'director' | 'manager' | 'ic';

export const ROLE_DISPLAY_NAMES: Record<OrgRole, string> = {
  ceo: 'CEO',
  vp: 'VP',
  director: 'Director',
  manager: 'Manager',
  ic: 'Individual Contributor',
};

export interface OrgPosition {
  id: string;
  organization_id: string;
  account_id: string;
  title: string;
  role: OrgRole;
  parent_id?: string | null;
  team_id?: string | null;
  user_id?: string | null;
  persona_id?: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface OrgTreeNode {
  position: OrgPosition;
  children: OrgTreeNode[];
}

export interface OrgChartResponse {
  root: OrgTreeNode | null;
  total_positions: number;
}

export interface CreatePositionRequest {
  title: string;
  role: OrgRole;
  parent_id?: string | null;
  user_id?: string | null;
  persona_id?: string | null;
}

export interface UpdatePositionRequest {
  title?: string | null;
  user_id?: string | null;
  persona_id?: string | null;
  clear_occupant?: boolean;
}

export interface MovePositionRequest {
  new_parent_id: string;
}
